import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import WorkOrderFollowUp from './work-order-follow-up';
import { useState } from 'react';
import { formatCurrency } from '../../risk-register/feching';

// ----------------------------------------------------------------------
export default function UserTableRow({ row,reloadBankInfo, selected, onEditRow, onSelectRow, onDeleteRow, serialNumber, WOId, chartsAccountList, bankInformation, reload , }) {
    const { project, status, remarks, work_order_number, work_order_date, total, created_by, balance  ,project_id} = row;

    const confirm = useBoolean();
    const create = useBoolean();
    const popover = usePopover();
        const [expanded, setExpanded] = useState(false);
    

    return (
        <>
            <TableRow hover selected={selected}>
                <TableCell padding="checkbox">
                    <Checkbox checked={selected} onClick={onSelectRow} />
                </TableCell>
                <TableCell>{serialNumber}</TableCell>
                <TableCell>{project?.name}</TableCell>
                <TableCell
                    style={{ cursor: 'pointer', color: 'blue' }}
                    onClick={create.onTrue}
                >
                    {work_order_number}
                </TableCell>
                <TableCell>{work_order_date}</TableCell>
                <TableCell>{created_by?.name}</TableCell>
                <TableCell>{work_order_date}</TableCell>
                <TableCell>{formatCurrency(total)}</TableCell>
                <TableCell>{formatCurrency(total - balance)}</TableCell>
                <TableCell>{formatCurrency(balance)}</TableCell>
                <TableCell onClick={() => setExpanded(!expanded)} style={{ cursor: "pointer" }}>
                    {expanded ? remarks : remarks?.length > 40 ? `${remarks?.slice(0, 40)}... See More` : remarks}
                </TableCell>
                <TableCell>{status === 1 ? "Yes" : "No"}</TableCell>
                <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
                    <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell>
            </TableRow>
            <WorkOrderFollowUp
                open={create.value}
                onClose={create.onFalse}
                WONumber={work_order_number}
                WOId={WOId}
                chartsAccountList={chartsAccountList}
                bankInformation={bankInformation}
                balance={balance}
                reload={reload}
                reloadBankInfo={reloadBankInfo}
                project_id={project_id}

            />
            <CustomPopover
                open={popover.open}
                onClose={popover.onClose}
                arrow="right-top"
                sx={{ width: 140 }}
            >
                <MenuItem
                    onClick={() => {
                        confirm.onTrue();
                        popover.onClose();
                    }}
                    sx={{ color: 'error.main' }}
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onEditRow(row);
                    }}
                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>
            <ConfirmDialog
                open={confirm.value}
                onClose={confirm.onFalse}
                title="Delete"
                content="Are you sure you want to delete?"
                action={
                    <Button
                        variant="contained" color="error"
                        onClick={() => {
                            confirm.onFalse();
                            onDeleteRow(row.id);
                        }}
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};
